if (!customElements.get('product-bar')) {
  class ProductBar extends HTMLElement {
    selectors = {
      title: '[product-bar="variant-title"]',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        title: this.querySelector(this.selectors.title),
      };

      this.boundaryEl = document.querySelector(this.dataset.boundary);

      if (!this.boundaryEl) {
        return;
      }

      this.setObserver();
      window.addEventListener('variant-change', (e) => {
        const title = e.detail.value;

        if (title && this.elements.title) {
          this.elements.title.textContent = title;
        }
      });
    }

    setObserver() {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
          document.documentElement.classList.toggle(
            'hide-header',
            !entry.isIntersecting,
          );
        },
        {
          threshold: 0,
          root: null,
        },
      );

      this.observer.observe(this.boundaryEl);
    }

    disconnectedCallback() {
      this.observer.unobserve(this.boundaryEl);
    }
  }
  customElements.define('product-bar', ProductBar);
}
